import { FeatureToggles } from "context/ApplicationConfig";

export const LEAN_SERVICES_MODE_TOGGLE = "lean_services_mode";

const LEAN_SERVICES_ALLOWED_ROUTE_FAMILIES = [
  "/",
  "/businesses",
  "/business",
  "/skilled-workers",
  "/jobs",
  "/laborpass",
  "/portfolio",
  "/pros",
  "/community-manager",
  "/training",
  "/auth",
  "/terms",
  "/privacy",
  "/cookie",
  "/pro-terms",
  "/about",
  "/faqs",
  "/contact",
  "/glossary",
];

export function isLeanServicesModeEnabled(toggles?: FeatureToggles) {
  return toggles?.[LEAN_SERVICES_MODE_TOGGLE] === true;
}

export function normalizeLeanServicesPath(pathname: string) {
  const [pathWithoutQuery] = pathname.split("?");
  const [normalizedPath] = pathWithoutQuery.split("#");

  if (!normalizedPath) {
    return "/";
  }

  return normalizedPath === "/"
    ? normalizedPath
    : normalizedPath.replace(/\/+$/, "");
}

export function isLeanServicesAllowedPath(pathname: string) {
  const normalizedPathname = normalizeLeanServicesPath(pathname);

  return LEAN_SERVICES_ALLOWED_ROUTE_FAMILIES.some(
    (path) =>
      normalizedPathname === path || normalizedPathname.startsWith(`${path}/`),
  );
}
